var map = {
	"./asda/default-messages": 144,
	"./electrodeio/default-messages": 145,
	"./samsclub/default-messages": 146,
	"./walmart/default-messages": 147
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 143;



//////////////////
// WEBPACK FOOTER
// ./src/lang/tenants ^\.\/.*\/default\-messages$
// module id = 143
// module chunks = 0